<template>
<h1><font-awesome-icon icon="gauge-high" /></h1>
<u>Luftdruck</u>
<br>
<DialGauge :value="value" :min="965" :max="1059" :label-radius="60" id-prefix="baro" />
<b>{{ value === null ? '--' : value }} hPa</b>
</template>

<script>
import DialGauge from './DialGauge.vue'

export default {
  name: 'AirPressure',
  components: { DialGauge },
  props: {
    pres: Number
  },
  computed: {
    // displayed value (sensor offset of 2 hPa is corrected here)
    value() {
      return Number.isFinite(this.pres) ? this.pres - 2 : null
    }
  }
}
</script>
